var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_605_3667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#610ECD",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "url(#paint0_linear_605_3667)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 16.5,
    width: 65,
    height: 65,
    rx: 13.3,
    stroke: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.75 42.3333V45.2718C67.2814 45.2257 66.781 45.196 66.25 45.1789V42.3333C66.25 39.6858 65.882 37.3429 64.4837 35.669C63.0683 33.9747 60.7021 33.0833 57 33.0833C53.2979 33.0833 50.9317 33.9747 49.5163 35.669C48.118 37.3429 47.75 39.6858 47.75 42.3333V45.1789C47.219 45.196 46.7186 45.2257 46.25 45.2718V42.3333C46.25 39.9379 46.544 37.259 48.0028 35.1833C49.4362 33.1439 52.072 31.5833 57 31.5833C61.928 31.5833 64.5638 33.1439 65.9972 35.1833C67.4561 37.259 67.75 39.9379 67.75 42.3333Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1824 46.3288L68.1824 46.3288L68.1896 46.3297C70.2433 46.5794 71.4228 47.1901 72.1313 48.2931C72.8692 49.442 73.1666 51.2228 73.1666 54V57.3333C73.1666 60.6702 72.7374 62.5555 71.6464 63.6465C70.5554 64.7374 68.6702 65.1667 65.3333 65.1667H48.6666C45.3297 65.1667 43.4445 64.7374 42.3535 63.6465C41.2625 62.5555 40.8333 60.6702 40.8333 57.3333V54C40.8333 51.2228 41.1307 49.442 41.8685 48.2931C42.577 47.1901 43.7565 46.5794 45.8103 46.3297L45.8103 46.3297L45.8175 46.3288C46.5232 46.2325 47.3339 46.1832 48.2544 46.1667H65.7454C66.666 46.1832 67.4766 46.2325 68.1824 46.3288ZM51.8605 57.213L51.8703 57.2037L51.8796 57.1939C52.2616 56.7906 52.4999 56.2364 52.4999 55.6667C52.4999 55.3742 52.4328 55.0922 52.3281 54.841C52.2223 54.5871 52.0747 54.356 51.8882 54.1489L51.8794 54.1391L51.8701 54.1298C51.2637 53.5234 50.3174 53.3263 49.5109 53.6704C49.226 53.7815 49.0106 53.936 48.8154 54.1117L48.7959 54.1293L48.7783 54.1489C48.5918 54.356 48.4442 54.5871 48.3384 54.841C48.2337 55.0922 48.1666 55.3742 48.1666 55.6667C48.1666 56.2364 48.4049 56.7906 48.7869 57.1939L48.8006 57.2083L48.8154 57.2217C49.0113 57.398 49.2275 57.5529 49.5139 57.6642C49.7635 57.7673 50.0432 57.8333 50.3333 57.8333C50.903 57.8333 51.4572 57.595 51.8605 57.213ZM58.5271 57.213L58.5416 57.1993L58.5549 57.1845C58.7413 56.9773 58.889 56.7463 58.9948 56.4923C59.0994 56.2412 59.1666 55.9592 59.1666 55.6667C59.1666 55.0778 58.9264 54.5407 58.5462 54.1395L58.5393 54.1321L58.5321 54.1251C57.7072 53.322 56.2775 53.3153 55.463 54.1298L55.4629 54.1297L55.4536 54.1395C55.0735 54.5407 54.8333 55.0778 54.8333 55.6667C54.8333 55.9592 54.9004 56.2412 55.005 56.4923C55.1109 56.7463 55.2585 56.9773 55.4449 57.1845L55.4583 57.1993L55.4727 57.213C55.874 57.5931 56.411 57.8333 56.9999 57.8333C57.5696 57.8333 58.1239 57.595 58.5271 57.213ZM65.1938 57.213L65.2036 57.2037L65.2129 57.1939C65.5949 56.7906 65.8333 56.2364 65.8333 55.6667C65.8333 55.5304 65.8122 55.3831 65.797 55.2774L65.7949 55.2626L65.795 55.2626L65.7931 55.2511C65.7694 55.1087 65.7245 54.9718 65.6625 54.8412C65.6165 54.7133 65.5491 54.5786 65.4548 54.4561C65.3799 54.3454 65.306 54.2531 65.2442 54.1758L65.2404 54.171L65.2231 54.1494L65.2035 54.1298C64.389 53.3153 62.9593 53.322 62.1344 54.1251L62.1272 54.1321L62.1203 54.1395C61.7401 54.5407 61.4999 55.0778 61.4999 55.6667C61.4999 56.2556 61.7401 56.7926 62.1203 57.1939L62.1296 57.2037L62.1394 57.213C62.5426 57.595 63.0969 57.8333 63.6666 57.8333C64.2363 57.8333 64.7906 57.595 65.1938 57.213Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_605_3667",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.37398 0 0 0 0 0.193943 0 0 0 0 0.607543 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_605_3667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_605_3667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_605_3667",
    x1: 25,
    y1: 17,
    x2: 89,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#DB6704",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DB6704",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPassword);
export default __webpack_public_path__ + "static/media/NewPassword.5eb8d9fec0ae9f044d504cef38012291.svg";
export { ForwardRef as ReactComponent };